// Photoreal level art as a slowly panning menu backdrop.
const base = `${process.env.PUBLIC_URL || ""}/game-assets`;
const BG = ["bg_managua", "bg_granada", "bg_sanjuan"];

export const MenuBackdrop = ({ themeIndex = 1 }) => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={`${base}/${BG[themeIndex] || BG[1]}.webp`}
        alt=""
        className="absolute inset-0 w-full h-full object-cover menu-pan"
        draggable={false}
      />
    </div>
  );
};
